<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to" />
      <input
        :name="validationLabel || label"
        :key="save_to"
        :required="required"
        :id="save_to"
        type="number"
        step="0.01"
        v-model="displayValue"
        :placeholder="placeholder"
        @blur="onBlur()"
        @change="onChange()"
        v-validate="rules"
      />
    </div>
    <span
      class="error"
      v-show="errors.has(validationLabel || label)"
      v-html="forceErrorMessage || errors.first(validationLabel || label)"
    ></span>
  </div>
</template>

<script>
import { validatorComponent } from "./validatorComponentMixin";
import { customBlurMixin } from "./customBlurMixin";

export default {
  name: "CurrencyInput",
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    placeholder: String,
    required: Boolean,
    validationLabel: String,
    forceErrorMessage: String,
    _id: String,
  },
  data: function () {
    return {
      amountCents: 0, // Store the amount in cents
    };
  },
  computed: {
    displayValue: {
      get() {
        if (this.amountCents === 0) {
          return "";
        }
        return this.amountCents / 100;
      },
      set(value) {
        this.amountCents = Math.round(parseFloat(value) * 100);
        if (isNaN(this.amountCents)) {
          this.amountCents = 0;
        }
        this.$emit("input", this.amountCents);
      },
    },
    rules() {
      return {
        required: this.required,
        min_value: 0, // Additional validation rules can be added as needed
        // Custom validation rules for currency (if needed) can be implemented here
      };
    },
  },
  watch: {
    amountCents(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("input", newValue);
      }
    },
  },
  methods: {
    onBlur() {
      // Custom blur logic here
    },
    onChange() {
      // Custom change logic here
    },
  },
};
</script>
